/* eslint-disable no-param-reassign */
import { PayloadAction, createSlice } from '@reduxjs/toolkit';

export interface MappingConfigState {
  marketList: MarketOption[];
}

type mappingConfigStateShape = {
  mappingConfig: MappingConfigState;
};
export interface MarketOption {
  id: number;
  name: string;
}

const initialState: MappingConfigState = {
  marketList: [],
};

const mappingConfigSlice = createSlice({
  name: 'mappingConfig',
  initialState,
  reducers: {
    setMarketList(state, action: PayloadAction<MarketOption[]>) {
      state.marketList = action.payload;
    },
  },
});

export const { setMarketList } = mappingConfigSlice.actions;

export const getMappingConfigState = (state: mappingConfigStateShape) =>
  state.mappingConfig;
export const getMarketList = (state: mappingConfigStateShape) =>
  state.mappingConfig.marketList;

export default mappingConfigSlice.reducer;
